import { __ } from '~/locale';

export const SHOW_PASSWORD = __('Reveal password');
export const HIDE_PASSWORD = __('Hide password');
